// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"aa75142e","11":"d9f952bc","21":"7b19a5a7","36":"6852166a","67":"189d2134","98":"a632249e","215":"f3db9b24","242":"5a2a6048","264":"048a463c","312":"191e74f4","400":"3854ffa9","426":"a6267ee7","489":"73caf752","922":"53505d0c"}[chunkId] + ".chunk.js";
};